// Central helper for WhatsApp CTAs.
// User will provide phone number later. For now we use the click-to-chat
// endpoint without number so it opens the WhatsApp chooser.
import { trackWhatsAppClick } from "@/lib/tracking";

const WHATSAPP_PHONE = process.env.REACT_APP_WHATSAPP_PHONE || "5511940383680"; // Ex: 5511999999999
export function buildWhatsAppUrl(message = "", customPhone = null) {
  const encoded = encodeURIComponent(message);
  const phoneToUse = customPhone || WHATSAPP_PHONE;
  if (phoneToUse && phoneToUse.length > 0) {
    return `https://api.whatsapp.com/send?phone=${phoneToUse}&text=${encoded}`;
  }
  // Opens WhatsApp with the message but no fixed recipient (chat picker).
  return `https://api.whatsapp.com/send?text=${encoded}`;
}

export function openWhatsApp(message = "", location = "site") {
  trackWhatsAppClick(location);

  // Now redirects to the RD Station form section
  const formSection = document.getElementById("rd-form-section");
  if (formSection) {
    formSection.scrollIntoView({ behavior: "smooth", block: "center" });
    // Focus the form container if possible to draw attention
    const rdContainer = document.getElementById("espontone-16aa058dd608303c1ceb");
    if (rdContainer) {
      rdContainer.classList.add("ring-4", "ring-[#C8A45D]", "ring-opacity-50", "rounded-lg", "transition-all", "duration-500");
      setTimeout(() => {
        rdContainer.classList.remove("ring-4", "ring-[#C8A45D]", "ring-opacity-50");
      }, 1500);
    }
  } else {
    // Fallback if not found (e.g. on other pages)
    window.location.href = "/#contato";
  }
}

export const WA_MESSAGES = {
  hero: "Oi! Quero saber mais sobre o lançamento em São Bernardo do Campo.",
  visit: "Oi! Quero agendar uma visita ao decorado do lançamento em SBC.",
  invest: "Oi! Quero investir no lançamento em SBC. Pode me enviar a tabela e condições?",
  live: "Oi! Quero morar no lançamento em SBC. Pode me enviar as condições?",
  finalCta: "Oi! Quero falar com um corretor sobre o apartamento em SBC agora.",
  general: "Oi! Quero saber mais sobre os apartamentos em SBC.",
  plant: (metragem, config) =>
    `Oi! Tenho interesse na planta de ${metragem} (${config}) do lançamento em SBC. Pode me passar valores e condições?`,
  leadForm: (name, phone, intent, region, payment) => {
    const intentStr = intent === "invest" ? "INVESTIR" : "MORAR";
    const regionStr = region === "SBC" ? "Apenas SBC" : region === "ABC" ? "Todo o ABC" : "Santo André";
    const payStr = payment === "standard" ? "Fluxo padrão" : "Parcela Baixa + Balão";
    return `Oi! Meu nome é ${name || "[nome]"}. Quero ${intentStr} num lançamento.
Busco na região: ${regionStr}.
Preferência de pagamento: ${payStr}.
Pode me enviar os valores e opções?`;
  },
};
